import React, {useState} from "react";
import {useTranslation} from "next-i18next";
import Input from "../../search/input";

/**
 *
 * @param data
 */
function initData(data) {
    // add a blank one
    return addBlankData(data);
}

/**
 *
 * @param data
 * @param id
 */
function removeFromData(data, id) {
   return data.filter(item => item.id !== id);
}

/**
 *
 * @param data
 * @returns {*}
 */
function addBlankData(data) {
    return [...data, {'id': 'trace-' + Date.now().toString(), 'name': '', 'translation': ''}];
}

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Traces ({ traces })
{
    // init
    const { t } = useTranslation();
    const [traceData, setTraceData] = useState(
        initData(traces)
    );

    /**
     *
     * @param event
     */
    function addTrace(event) {
        event.preventDefault();
        event.target.blur();
        setTraceData(
            traceData => addBlankData(traceData)
        );
    }

    /**
     *
     * @param event
     */
    function removeTrace(event) {
        event.preventDefault();
        event.target.blur();

        // reduce the trace-data by filtering out this id
        const id = event.target.getAttribute('data-eqno-trace-id');
        setTraceData(
            traceData => removeFromData(traceData, id)
        );
    }

    // render
    return (
        <>
            {/* Labels */}
            <div className="row justify-content-center justify-content-lg-start">
                <div className="mb-1 col-10 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                    <label htmlFor="trace">{t('trace')}</label>
                </div>
                <div className="mb-1 col-2 col-sm-2 col-md-1">
                    <label className="text-center" htmlFor="moreTraces">{t('more')}</label>
                </div>
            </div>


            {/* Traces */}
            {traceData.map((trace, index) =>
                <div key={'trace-' + trace.id + '-' + index} className="row justify-content-center justify-content-lg-start">
                    {/* Name */}
                    <div className="position-relative col-10 col-sm-8 col-md-6 col-lg-5 col-xl-4 mb-3">
                        <Input
                            type={'trace'}
                            defaultValue={trace.translation ?? trace.name}
                            multiple={true}
                            placeholder={t('trace')}
                            name={null}
                            required={false}
                            loadOnChoose={false}
                        />
                    </div>

                    {/* More or less */}
                    <div className="col-2 col-sm-2 col-md-1 mb-3">
                        <button data-eqno-trace-id={trace.id} onClick={index === (traceData.length - 1) ? addTrace : removeTrace} className={"form-control btn fw-bolder ps-0 pe-0" + ((index === traceData.length - 1) ? ' btn-outline-primary' : ' btn-outline-danger')} type="button">
                            {index === (traceData.length - 1) ? '+' : '-'}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}